const FIRST_TAB = 0;
const SECOND_TAB = 1;
const THIRD_TAB = 2;

export { FIRST_TAB, SECOND_TAB, THIRD_TAB };
